// extracted by mini-css-extract-plugin
module.exports = {"container":"_db7ce2e","value":"_4bb3ab7"};